import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Shield } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';


const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.5, ease: 'easeOut', delay },
});

function AccordionItem({ item, index, isOpen, onToggle }) {
  return (
    <div className={`border rounded-xl overflow-hidden transition-colors duration-200
      ${isOpen ? 'border-[#D5A63B]/40' : 'border-[#0F6B49]/20 hover:border-[#0F6B49]/40'}`}
      data-testid={`faq-item-${index}`}>
      <button
        onClick={onToggle}
        className="w-full flex items-center justify-between px-6 py-4 bg-[#171E26] text-left gap-4"
        data-testid={`faq-toggle-${index}`}
        aria-expanded={isOpen}>
        <span className="font-exo font-bold text-[#F3F1EB] text-base leading-snug">{item.q}</span>
        <ChevronDown size={18} className={`text-[#D5A63B] flex-shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
      </button>
      <AnimatePresence>
        {isOpen && (
          <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.2 }}>
            <div className="px-6 pb-5 pt-3 bg-[#1A222B] border-t border-[#0F6B49]/15">
              <p className="text-[#8A9099] text-sm leading-relaxed">{item.a}</p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default function FAQ() {
  const { t } = useLanguage();
  const faq = t.faq;
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="py-14 md:py-20 bg-[#1A222B]" data-testid="faq-section">
      <div className="section-container">
        <motion.div className="text-center mb-12" {...fadeUp()}>
          <div className="divider-gold mx-auto" />
          <h2 className="heading-lg">{faq.title}</h2>
        </motion.div>

        <div className="max-w-2xl mx-auto space-y-3">
          {faq.items.map((item, i) => (
            <motion.div key={i} {...fadeUp(0.05 * i)}>
              <AccordionItem item={item} index={i} isOpen={openIndex === i}
                onToggle={() => setOpenIndex(openIndex === i ? -1 : i)} />
            </motion.div>
          ))}
        </div>

        {/* Disclaimer */}
        <motion.div className="mt-10 max-w-2xl mx-auto flex items-start gap-3 bg-[#0F6B49]/10 border border-[#0F6B49]/30 rounded-xl p-4"
          {...fadeUp(0.4)}>
          <Shield size={18} className="text-[#D5A63B] flex-shrink-0 mt-0.5" />
          <p className="text-[#8A9099] text-sm">{t.footer.legal}</p>
        </motion.div>
      </div>
    </section>
  );
}
